import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, fileUrl } from "@/lib/api";

const SiteImagesContext = createContext({ images: {}, reload: () => {} });

export const SiteImagesProvider = ({ children }) => {
  const [images, setImages] = useState({});
  const load = useCallback(() => {
    api.get("/site-images")
      .then(r => setImages(r.data || {}))
      .catch(() => setImages({}));
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <SiteImagesContext.Provider value={{ images, reload: load }}>
      {children}
    </SiteImagesContext.Provider>
  );
};

export const useSiteImage = (key, fallback = "") => {
  const { images } = useContext(SiteImagesContext);
  const raw = images[key];
  if (!raw) return fallback;
  return fileUrl(raw);
};

export const useSiteImagesReload = () => {
  const { reload } = useContext(SiteImagesContext);
  return reload;
};
